import { checkResponse } from "store/utils";
import { ApiResponse } from "store/api/types";
import { call } from "redux-saga/effects";
import { touchReport } from "../api";

export function* touchReportSaga(action: any) {
  const {reportId} = action.payload;
  try {
    const response: ApiResponse = yield call(touchReport, reportId);

    const err = checkResponse(response?.responseMessage);
    if (err) throw err;

  } catch (error: any) {
    console.log('Failed to refresh report: ', reportId);
  }
}